export default class Product {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => {
			if(window.tccdata.selected_store_id) {
				this.enableAddToCartInputs();
			}
		}, false);

		window.addEventListener('branchModified', (e) => {
			console.log(window.tccdata.stores[window.tccdata.selected_store_id].slug);
			jQuery('#pa_branches').val(window.tccdata.stores[window.tccdata.selected_store_id].slug);
			jQuery('#pa_branches').trigger('change');
			this.enableAddToCartInputs();
		}, false);
	}

	registerMyAccountHandlers() {

	}

	disableAddToCartInputs() {
		jQuery('.single_add_to_cart_button').prop('disabled', true);
		jQuery('.quantity input').prop('disabled', true)
	}

	enableAddToCartInputs() {
		jQuery('.single_add_to_cart_button').addClass('active');
		jQuery('.quantity').addClass('active');
		jQuery('.single_add_to_cart_button').prop('disabled', false);
		jQuery('.quantity input').prop('disabled', false)
	}
}
